import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant, EstadosTablaComunConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import * as FormGroups from './formGroups'

const EditarZonaModal = ({ handleClose, show, modalData, tipoTabla, onSuccess }) => {
  const __zariContext = React.useContext(ZariContext)

  const nombreTabla = React.useMemo(() => {
    return TiposTablaPersonalizadaConstant.__dictionary[tipoTabla].nombre
  }, [tipoTabla])

  const formInitialValues = React.useMemo(
    () => ({
      _id: modalData._id,
      brevete: modalData.brevete || '',
      codigo: modalData.codigo || '',
      _idListaPrecio: modalData._idListaPrecio || '',
      _idServicio: modalData._idServicio || '',
      _idSubServicio1: modalData._idSubServicio1 || '',
      cuentaContable: modalData.cuentaContable || '',
      estado: modalData.estado || EstadosTablaComunConstant.HABILITADO,
      flagECommerce: modalData.flagECommerce || false,
      flagPrincipal: modalData.flagPrincipal || false,
      marca: modalData.marca || '',
      nombre: modalData.nombre || '',
      numeroDocumentoIdentificacion: modalData.numeroDocumentoIdentificacion || '',
      placa: modalData.placa || '',
      texto: modalData.texto || '',
      tipoDocumentoIdentificacion: modalData.tipoDocumentoIdentificacion || '',
      valorSunat: modalData.valorSunat || '',
      tipo: tipoTabla
    }),
    [modalData, tipoTabla]
  )

  const submitHandler = async data => {
    if (modalData._id) {
      await TablasPersonalizadasService.eliminarxId(data._id)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          onSuccess()
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  const modalBodyComponents = React.useCallback(
    ({ errors, isSubmitting, touched, values, setFieldValue }) => {
      switch (tipoTabla) {
        case TiposTablaPersonalizadaConstant.GRUPOCONTABLECOMPRA:
          return (
            <>
              <FormGroups.CuentaContableFormGroup
                iError={errors.cuentaContable}
                iTouched={touched.cuentaContable}
                fIsSubmitting={isSubmitting}
                iValue={values.cuentaContable}
                iReadonlyInfo={values.cuentaContable}
                setFieldValue={setFieldValue}
              />
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
            </>
          )
        default:
          return null
      }
    },
    [tipoTabla]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>{`Eliminar - ${nombreTabla}`}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              {modalBodyComponents({ errors, isSubmitting, touched, values, setFieldValue })}
              <FormGroups.EstadoFormGroup iError={errors.estado} iTouched={touched.estado} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Eliminar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default EditarZonaModal
